import { CSV_FORMULA_TRIGGERS } from "./constants";

/** Quotes a CSV cell and stops it running as a formula. */
export const toCsvCell = (value: string | number): string => {
  const text = String(value);
  const safeText = CSV_FORMULA_TRIGGERS.some((trigger) => text.startsWith(trigger))
    ? `'${text}`
    : text;
  return `"${safeText.replace(/"/g, (quote) => quote + quote)}"`;
};
